












import {ActiveFormOptionsStep} from './BZCore/ActiveForm'
import UiInlineIcon from '../Icon/InlineIcon.vue'

export default {
  name: 'Steps',
  components: {UiInlineIcon},
  props: {
    step: {
      type: Number as () => number,
      default: 0
    },
    steps: {
      type: Array as () => ActiveFormOptionsStep[],
      default: 0
    }
  }
}
